<ng-template #noPendingRequests>
    <div class="col-12 text-center error-block-large">
        {{ 'NO_PENDING_REQUESTS' | translate }}
    </div>
</ng-template>
<h2 class="col-sm-12 text-blue">{{ "APPROVE_REGISTRATION_TEXT" | translate }}</h2>
  <div class = "loading-overlay" *ngIf="loading">
    <div class="spinner" role="status" aria-live="polite" aria-label="Loading"></div>
    <div class="spinner-text">{{ 'LOADING_TEXT' | translate }}</div>
  </div>
    <div class="white-background-box">
        <div class="find-register-form-box">
            <p class="head-description-text">{{ "APPROVE_OR_REJECT_REGISTRATION_TEXT" | translate }}</p>
            <form name="searchUserForm" [formGroup]="searchForm" class="form-group" novalidate>
                <div class="radio-btn-row">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="userSearch" id="email" value="email"
                            (change)="searchFormChange('email')" checked placeholder="{{'EMAIL' | translate}}" tabindex="0" />
                        <label class="form-check-label" for="email">{{
                            "EMAIL" | translate
                            }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="userSearch" id="accountNumber"
                            value="accountNumber" (change)="searchFormChange('account')"
                            placeholder="{{'ACCOUNT_NUMBER_TEXT' | translate}}" tabindex="0"/>
                        <label class="form-check-label" for="accountNumber">{{
                            "ACCOUNT_NUMBER_TEXT" | translate
                            }}</label>
                    </div>
                </div>
                <div class="text-btn-row">
                    <div class="form-group manageUser-searchContainer w-55">
                        <span *ngIf="email" class="user-input">
                            <div class="form-floating">
                                <input name="email" formControlName="emailSearch" maxlength="100"
                                    [(ngModel)]="searchUser.emailSearch" placeholder="LOGIN_EMAIL_PLACEHOLDER_KEY"
                                    [class]="searchForm.get('emailSearch')?.invalid &&
                                    searchForm.get('emailSearch')?.dirty?'text-input form-control is-invalid':
                                    'text-input form-control'" type="text"/>
                                <label for="" class="control-label">{{ 'LOGIN_EMAIL_PLACEHOLDER_KEY' | translate
                                    }}</label>
                                <div class="w-100" *ngIf="
                                    searchForm.get('emailSearch')?.invalid &&
                                    searchForm.get('emailSearch')?.dirty">
                                    <span class="error-block">{{
                                        "EMAIL_VALID_TEXT" | translate
                                        }}</span>
                                </div>
                            </div>
                        </span>
                        <span *ngIf="accountNumber" class="user-input">
                            <div class="form-floating">
                                <input name="accountNumber" type="text" minlength="2" maxlength="14"
                                    formControlName="accountNumberSearch"
                                    [(ngModel)]="searchUser.accountNumberSearch"
                                    [class]="searchForm.get('accountNumberSearch')?.invalid &&
                                    searchForm.get('accountNumberSearch')?.dirty?'user-input form-control is-invalid':'user-input form-control'"
                                    placeholder="{{'ACCOUNT_NUMBER_TEXT' | translate}}" />
                                <label for="" class="control-label">{{'ACCOUNT_NUMBER_TEXT' | translate}}</label>
                                <div class="w-100" *ngIf="
                                searchForm.get('accountNumberSearch')?.invalid &&
                                searchForm.get('accountNumberSearch')?.dirty
                                          ">
                                </div>
                            </div>
                        </span>

                        <button [disabled]="choice === 'email' && searchForm.get('emailSearch')?.invalid" type="submit" name="find" (click)="searchFunc()" class="btn blue-bg btn-sm cta-blue info-btn sec-btn btn-width" style="margin-right:10px;">
                            {{ "FIND_TEXT" | translate }}
                        </button>
                        <button (click)="resetSearch()" class="btn btn-sm cta-blue info-btn sec-btn btn-width">
                            {{ "RESET_KEY" | translate }}
                        </button>
                    </div>
                    <div class="flex-row justify-end w-45">
                    </div>
                </div>
            </form>
        </div>
    <div *ngIf="hasSearchCondition && userSearchCondition" class="mt-6 text-large">
        <strong>{{'SEARCH_RESULTS_TEXT' | translate }}</strong>
        {{choice}}
    </div>

    <form name="addAccountForm" novalidate>
      <table class="search-result-table" style="margin-top:10px;" aria-describedby="">
        <thead class="table-header">
          <tr>
            <th scope="col" class="pl-4">{{'STATUS' | translate}}</th>
            <th scope="col">{{'EMAIL' | translate}}</th>
            <th scope="col">{{'TL_NAME_LABEL' | translate}}</th>
            <th scope="col">{{'COMPANY_NAME' | translate}}</th>
            <th scope="col">{{'ACCOUNT_NUMBER_TEXT' | translate}}</th>
            <th scope="col">{{'CREATE_DATE_TEXT' | translate}}</th>
            <th scope="col">{{'OPERATION_TEXT' | translate}}</th>
            <th scope="col">{{'SUBMIT_TEXT' | translate}}</th>
          </tr>
        </thead>
          <tbody class="table-content">
            <ng-container *ngFor="let row of flattenedAccountList; trackBy: trackAccount">
              <tr>
                <td class="pl-4">{{ ['PR','DR'].includes((row.user.status || '').toUpperCase()) ? 
                  ('NEW_TEXT' | translate) : ('EXISTING_TEXT' | translate) }}</td>
                <td [title]="row.user.emailAddress">{{ row.user.emailAddress | slice:0:27 }}</td>
                <td [title]="(row.user.firstName || '') + ' ' + (row.user.lastName || '')">
                  {{ ((row.user.firstName || '') + ' ' + (row.user.lastName || '')) | slice:0:15 }}
                </td>
                <td [title]="row.user.companyName">{{ row.user.companyName | slice:0:15 }}</td>
                <td [title]="row.acc.accountNumber">{{ row.acc.accountNumber | slice:0:12 }}</td>
                <td [title]="row.acc.createDate">
                  <ng-container *ngIf="row.acc.createDate?.length >= 8">
                    {{ row.acc.createDate | slice:0:4 }}/{{ row.acc.createDate | slice:4:6 }}/{{ row.acc.createDate | slice:6:8 }}
                  </ng-container>
                </td>
                <td>
                  <select class="form-select form-select-sm operation-select" [(ngModel)]="row.acc.decision"
                          [ngModelOptions]="{ standalone: true }" (ngModelChange)="onDecisionChange(row.user, row.acc)">
                      <option [ngValue]="undefined">{{ 'SELECT_TEXT' | translate }}</option>
                      <option value="A">{{ 'APPROVE_TEXT' | translate }}</option>
                      <option value="R">{{ 'REJECT_TEXT' | translate }}</option>
                      <option value="P">{{ 'PENDING_TEXT' | translate }}</option>
                  </select>
                </td>
                <td>
                  <button class="btn btn-primary-find blue-bg text-bold-14 dispute-button" [disabled]="!row.acc.decision || row.acc.isSubmitting"
                          (click)="submitDecision(row, row.acc)">
                      <span *ngIf="!row.acc.isSubmitting && !row.acc.submitDone && !row.acc.submitError">
                      {{ 'SUBMIT_TEXT' | translate }}
                      </span>
                      <span *ngIf="row.acc.isSubmitting">...</span>
                      <span *ngIf="row.acc.submitDone">✔</span>
                      <span *ngIf="row.acc.submitError">✖</span>
                  </button>
                  <div *ngIf="row.acc.decision === 'R' && row.acc.rejectionReason" class="mt-1 small text-danger">
                    {{ row.acc.rejectionReason }}
                  </div>
                </td>
              </tr>
            </ng-container>
              <tr *ngIf="!flattenedAccountList || flattenedAccountList.length === 0">
                  <td colspan="7" class="p-0">
                  <ng-container *ngTemplateOutlet="noPendingRequests"></ng-container>
                  </td>
              </tr>
          </tbody>
      </table>
        <div *ngIf="totalPages > 1" class="mt-3 d-flex justify-content-center">
          <nav class="pagination-nav" aria-label="Registration accounts pages">
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="p <= 1">
                <button class="page-link icon"
                        (click)="goPrev()"
                        [disabled]="p <= 1"
                        [attr.aria-disabled]="p <= 1 ? 'true' : null">
                  <span aria-hidden="true" class="chevron">&laquo;</span>
                  {{ 'PREVIOUS' | translate }} {{ isFirst }}
              </button>
              </li>
              <li *ngFor="let pg of pages"
                  class="page-item"
                  [class.active]="pg === p"
                  [class.disabled]="pg === '...'">
                <button class="page-link"
                        *ngIf="pg !== '...'; else ellipsisTpl"
                        (click)="onPageClick(pg)"
                        [attr.aria-current]="pg === p ? 'page' : null">
                  {{ pg }}
                </button>
                <ng-template #ellipsisTpl>
                  <span class="page-link ellipsis" aria-hidden="true">…</span>
                </ng-template>
              </li>

              <li class="page-item" [class.disabled]="p >= totalPages">
                <button class="page-link"
                        (click)="goNext()"
                        [disabled]="p >= totalPages"
                        [attr.aria-disabled]="p >= totalPages ? 'true' : null">
                  {{ 'NEXT' | translate }} <span aria-hidden="true" class="chevron-next">&raquo;</span>
                </button>
              </li>
            </ul>
          </nav>
        </div>
    </form>

  </div>
